import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import "firebase/database";

const firebaseConfig = {
	 apiKey: "AIzaSyDj5RePj9oHD-0Xu_Ms1aVmfoPZ0QlAJx0",
  authDomain: "blumeessa-e2dca.firebaseapp.com",
  databaseURL: "https://blumeessa-e2dca-default-rtdb.firebaseio.com",
  projectId: "blumeessa-e2dca",
  storageBucket: "blumeessa-e2dca.firebasestorage.app",
  messagingSenderId: "888315938239",
  appId: "1:888315938239:web:dc0b14adde27aba6700d0a"
};

const fire = initializeApp(firebaseConfig);
const auth = getAuth(fire);
const analytics = getAnalytics(fire);
export default fire;
export { auth, analytics };
